export const ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,.ppt,.pptx';

const MIME_TYPE_BY_EXTENSION = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
} as const;

const ALLOWED_ATTACHMENT_MIME_TYPES = new Set<string>(Object.values(MIME_TYPE_BY_EXTENSION));
const GENERIC_ATTACHMENT_MIME_TYPES = new Set([
  '',
  'application/octet-stream',
  'application/zip',
  'application/x-zip-compressed',
]);

function getExtension(fileName: string): keyof typeof MIME_TYPE_BY_EXTENSION | null {
  const trimmed = fileName.trim().toLowerCase();
  const dotIndex = trimmed.lastIndexOf('.');
  if (dotIndex < 0 || dotIndex === trimmed.length - 1) return null;

  const extension = trimmed.slice(dotIndex + 1);
  if (extension in MIME_TYPE_BY_EXTENSION) {
    return extension as keyof typeof MIME_TYPE_BY_EXTENSION;
  }

  return null;
}

export function getAttachmentContentType(file: Pick<File, 'name' | 'type'>): string | null {
  const extension = getExtension(file.name);
  const extensionContentType = extension ? MIME_TYPE_BY_EXTENSION[extension] : null;
  const reportedContentType = file.type.trim().toLowerCase();

  if (extensionContentType) {
    if (
      GENERIC_ATTACHMENT_MIME_TYPES.has(reportedContentType) ||
      ALLOWED_ATTACHMENT_MIME_TYPES.has(reportedContentType)
    ) {
      return extensionContentType;
    }
  }

  if (!extensionContentType && ALLOWED_ATTACHMENT_MIME_TYPES.has(reportedContentType)) {
    return reportedContentType;
  }

  return null;
}

export function isAllowedAttachmentFile(file: Pick<File, 'name' | 'type'>): boolean {
  return getAttachmentContentType(file) !== null;
}
